import * as yup from 'yup';

interface TestContextExtended {
    [key: string]: any;
}

const alphaNumericRegex = /^[a-zA-Z0-9]+$/;
const alphaNumaricRegexOf26 = /^[a-zA-Z0-9]{26}$/;
const numericalRegex = /^\d{6,8}$/;

function allocationRulesValidationSchema() {
    return yup.object({
        program_id: yup.string()
            .trim('This field cannot contain white spaces')
            .nullable()
            .test(
                'programidtest',
                'Program id must be alphanumeric characters of 26 or numeric of 6-8',
                (value) => {
                    if (!value){
                        return false;
                    }
                    if (!alphaNumaricRegexOf26.test(value) && !numericalRegex.test(value)) {
                        return false;
                    }
                    return true;
                }
            ),
        lot_id: yup.string()
            .trim('This field cannot contain white spaces')
            .nullable()
            .test(
                'lotidtest',
                'Lot id must be alphanumeric characters of 26 or numeric of 6-8.',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    if (from[0].value.tempParams.ruleFor === 'lotId') {
                        if (!value){
                            return false;
                        }
                        if (!alphaNumaricRegexOf26.test(value) && !numericalRegex.test(value)) {
                            return false;
                        }
                    }
                    return true
                }
            ),
        campaign_id: yup.string()
            .trim('This field cannot contain white spaces')
            .nullable()
            .test(
                'campaignidtest',
                'Campaign id must be alphanumeric characters of 26 or numeric of 6-8',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    if (from[0].value.tempParams.ruleFor === 'campaignId') {
                        if (!value){
                            return false;
                        }
                        if (!alphaNumaricRegexOf26.test(value) && !numericalRegex.test(value)) {
                            return false;
                        }
                    }
                    return true
                }
            ),
        currency_id: yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9@]+$/, 'This field cannot contain white spaces and special characters')
            .test(
                'currencyidtest',
                'Currency id has to be provided and can contain only alphanumeric values',
                (value) => {
                    if (!value || !value.match(alphaNumericRegex)) {
                        return false
                    }
                    return true
                }
            ),
        amount: yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9@]+$/, 'This field cannot contain white spaces and special characters')
            .test(
                'amounttest',
                'Amount has to be provided and can contain only positive number',
                (value) => {
                    if (!value || (!(Number.isInteger(Number(value))) || Number(value) <= 0)) {
                        return false
                    }
                    return true
                }
            ),
        validity: yup.string()
            .nullable()
            .matches(/^[a-zA-Z0-9@]+$/, 'This field cannot contain white spaces and special characters')
            .test(
                'validitytest',
                'Valitidy can contain only positive number',
                (value) => {
                    if (value && (!(Number.isInteger(Number(value))) || Number(value) < 0)) {
                        return false
                    }
                    return true
                }
            )
    })
}

export { allocationRulesValidationSchema }
